import { PhoneNumberType } from "@enums/phone-number-type.enum";

export interface PhoneNumberModel {
  number: string;
  type: PhoneNumberType;
  userId: string;
}

export class PhoneNumber implements PhoneNumberModel {
  number = "";
  type = PhoneNumberType.Home;
  userId = "";
  phoneReg?: RegExp;

  constructor(dto?: PhoneNumberModel) {
    if (!dto) return;

    Object.assign(this, dto);
  }
}
